//import { firebase } from "../store/firestore";
import store from "../store";

export class FirestoreUploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
    this.uploadTask;
  }

  upload() {
    return this.loader.file.then(
      file =>
        new Promise((resolve, reject) => {
          var storage = store.state.st;
          var uid = store.state.auth().currentUser.uid;
          var filename =
            Date.now() + file.name.slice(file.name.lastIndexOf("."));
          var path = `users/${uid}/${filename}`;
          var storageRef = storage.ref(path);
          this.uploadTask = storageRef.put(file);
          this.uploadTask.on(
            "state_changed",
            function(snapshot) {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              // console.log("Upload is " + progress + "% done");
              store.dispatch("sendNotification", {
                snackbar: true,
                color: "success",
                timeout: 5000,
                text: "Upload is " + parseInt(progress) + "% done"
              });
            },
            function(error) {
              // console.log("Error", error);
              reject({ error: error });
            },
            function() {
              // console.log(this.uploadTask);
              this.uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function(downloadURL) {
                  store.dispatch("sendNotification", {
                    snackbar: true,
                    color: "success",
                    timeout: 5000,
                    text: "Image saved."
                  });
                  resolve({
                    default: downloadURL
                  });
                });
            }.bind(this)
          );
        })
    );
  }
  abort() {
    //console.log("Cancel upload");
    store.dispatch("sendNotification", {
      snackbar: true,
      color: "warning",
      timeout: 5000,
      text: "File upload canceled"
    });
    this.uploadTask.cancel();
  }
}
